export enum CesiumModuleAssetType {
  Image = 1,
  Area = 2,
  Video = 3,
  Metadata = 4,
  Panorama = 5,
}

export interface CesiumModuleAssetImage {
  fileSize: number;
  latitude: number;
  longitude: number;
  altitude?: number;
}

export interface CesiumModuleAsset {
  id: number;
  assetType: CesiumModuleAssetType;
  title: string;
  description?: string;
  order: number;
  tags: string[];
  image?: CesiumModuleAssetImage;
  createdBy: string;
  createdDate: Date;
  updatedBy?: string;
  updatedDate: Date;
}

export interface CesiumModuleAssetSummary {
  id: number;
  assetType: CesiumModuleAssetType;
  title: string;
  description?: string;
  tags: string[];
  latitude?: number;
  longitude?: number;
  createdBy: string;
  createdDate: Date;
  projectId: number;
  projectPostFileId: number;
  canEdit: boolean;
  canDelete: boolean;
}

export interface CesiumModuleAssetList {
  assets: CesiumModuleAssetSummary[];
  total: number;
  skip: number;
  take: number;
}

export interface CesiumModuleAssetPermissions {
  canView: boolean;
  canEdit: boolean;
  canDelete: boolean;
  userId?: string;
  userName?: string;
}

export interface UploadCesiumImageAssetRequest {
  file: File;
  title: string;
  description?: string;
  latitude: number;
  longitude: number;
  altitude?: number;
  tags?: string; // Comma-separated
}

export interface UpdateCesiumModuleAssetRequest {
  title: string;
  description?: string;
  latitude?: number;
  longitude?: number;
  altitude?: number;
  tags?: string; // Comma-separated
  order?: number;
}
